import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';

export const useInsightsAdminRole = () => {
  const location = useLocation();
  const { user, switchRole, initialCheckDone } = useUser();
  const [checkedPath, setCheckedPath] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const ensureAdminRole = async () => {
      if (!initialCheckDone) return;

      if (user?.role_name?.toLowerCase() === 'author') {
        const adminRole = (user.roles || []).find(
          role => role.name?.toLowerCase() === 'admin' || role.description?.toLowerCase() === 'admin'
        );

        if (adminRole?.id) {
          await switchRole(adminRole.id);
        }
      }

      if (!cancelled) setCheckedPath(location.pathname);
    };

    ensureAdminRole();
    return () => { cancelled = true; };
  }, [location.pathname, initialCheckDone, user, switchRole]);

  return checkedPath === location.pathname;
};